/**
 * generalOutline.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 개요 탭에서 사용하는 데이터의 모음입니다.
 * 일부 데이터는 직접 개요 페이지 컴포넌트에 넣는 경우도 존재합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import img1 from 'assets/Desktop/images/parcelOut/summary_planimages_84a.png';
import img2 from 'assets/Desktop/images/parcelOut/summary_planimages_84b.png';
import img3 from 'assets/Desktop/images/parcelOut/summary_planimages_84c.png';
import img4 from 'assets/Desktop/images/parcelOut/summary_planimages_108.png';
import img5 from 'assets/Desktop/images/parcelOut/summary_planimages_116.png';

import bgPremium1 from 'assets/Desktop/images/parcelOut/premium_01.jpg';
import bgPremium2 from 'assets/Desktop/images/parcelOut/premium_02.jpg';
import bgPremium3 from 'assets/Desktop/images/parcelOut/premium_03.jpg';
import bgPremium4 from 'assets/Desktop/images/parcelOut/premium_04.jpg';

import bgPremiumMo1 from 'assets/Mobile/images/ParcelOut/premium_m_01.jpg';
import bgPremiumMo2 from 'assets/Mobile/images/ParcelOut/premium_m_02.jpg';
import bgPremiumMo3 from 'assets/Mobile/images/ParcelOut/premium_m_03.jpg';
import bgPremiumMo4 from 'assets/Mobile/images/ParcelOut/premium_m_04.jpg';


/**
 * 개요 탭의 분양일정 메뉴에 사용되는 데이터입니다.
 */
export const dataCalender = [
  { date: '2022.09.30', detail: '주택전시관 오픈' },
  { date: '10.11', detail : '특별공급 청약'},
  { date: '10.12', detail : '1순위 청약'},
  { date: '10.13', detail : '2순위 청약'},
  { date: '10.31~11.02', detail : '정당계약'}
];

/**
 * @데스크탑프리미엄deprecated
 * 개요의 프리미엄 메뉴에 사용되는 데이터입니다.
 */
export const dataPremium = [
  {
    img: bgPremium1,
    subtit: 'PREMIUM 1',
    tit: '기대되는 미래가치 \n구미에서 만나는 No.1 브랜드',
    detail:'편리한 생활환경, 쾌속교통,\n대기업의 대규모 투자로 기대되는 미래가치까지'
  },
  {
    img: bgPremium2,
    subtit: 'PREMIUM 2',
    tit: '금오산으로 삶의 여유까지 더하는\n완벽한 브랜드 라이프',
    detail:'직주근접, 편리한 광역교통, 우수한 교육환경,\n금오산을 품은 그리너리라이프'
  },
  {
    img: bgPremium3,
    subtit: 'PREMIUM 3',
    tit: 'e편한세상의 역량이 집중된\n라이프스타일\n맞춤 주거 플랫폼 C2하우스',
    detail:'남향위주 배치(일부세대 제외)와\n전세대 중대형(84㎡~116㎡)으로 구성된\n620세대 대단지\n\n유해물질로부터 안전하고 쾌적한 생활을 할 수 있는 스마트 클린&케어 솔루션 적용'
  },
  {
    img: bgPremium4,
    subtit: 'PREMIUM 4',
    tit: '구미의 자부심이 되는\ne편한세상의 브랜드 프리미엄',
    detail:'프리미엄 브랜드 e편한세상에서\n더 높은 삶의 자부심을 만납니다.'
  }
];

/**
 * @모바일프리미엄
 * 개요의 프리미엄 메뉴에 사용되는 데이터입니다.
 */
 export const moPremium = [
  {
    moImg: bgPremiumMo1,
    subtit: 'PREMIUM 1',
    tit: '기대되는 미래가치 구미에서 만나는 No.1 브랜드',
    detail:'편리한 생활환경, 쾌속교통, 대기업의 대규모 투자로 기대되는 미래가치까지'
  },
  {
    moImg: bgPremiumMo2,
    subtit: 'PREMIUM 2',
    tit: '금오산으로 삶의 여유까지 더하는 완벽한 브랜드 라이프',
    detail:'직주근접, 편리한 광역교통, 우수한 교육환경, 금오산을 품은 그리너리라이프'
  },
  {
    moImg: bgPremiumMo3,
    subtit: 'PREMIUM 3',
    tit: 'e편한세상의 역량이 집중된 라이프스타일 맞춤 주거 플랫폼 C2하우스',
    detail:'남향위주 배치(일부세대 제외)와 전세대 중대형(84㎡~116㎡)으로 구성된 620세대 브랜드 대단지\n\n유해물질로부터 안전하고 쾌적한 생활을 할 수 있는 스마트 클린&케어 솔루션 적용'
  },
  {
    moImg: bgPremiumMo4,
    subtit: 'PREMIUM 4',
    tit: '구미의 자부심이 되는 e편한세상의 브랜드 프리미엄',
    detail:'프리미엄 브랜드 e편한세상에서 더 높은 삶의 자부심을 만납니다.'
  }
];

/**
 * 평방미터를 평형으로 계산하기 위한 기본 고정 값입니다.
 * 평방미터 * CAL_FEET 하여 처리하며 Math.floor(평방미터(공급면적) * CAL_FEET)를 하여 소수점을 없앱니다.
 */
const CAL_FEET: number = 0.3025;

/**
 * 개요의 세대정보 메뉴에 사용되는 데이터입니다.
 */
export const dataSlide = [
  {
    img: img1,
    title: '84㎡A형',
    titleSwitchActive: `${Math.floor(108.1022 * CAL_FEET)}평A형`,
    subTitle: '16세대',
    subTitle02: '321',
    total: '153',
    detail: '우수한 개방감과 여유로운 공간구성, 주방 원스톱 세탁실 등을 갖춰 \n생활의 편리함을 극대화한 판상형 구조'
  },
  {
    img: img2,
    title: '84㎡B형',
    titleSwitchActive: `${Math.floor(108.8709 * CAL_FEET)}평B형`,
    subTitle: '259세대',
    subTitle02: '22',
    total: '27',
    detail: '부부공간과 자녀공간을 분리하여 공간별 프라이버시가 확보되고, \n열린 거실과 오픈형 주방을 갖춘 탑상형 구조'
  },
  {
    img: img3,
    title: '84㎡C형',
    titleSwitchActive: `${Math.floor(108.9254 * CAL_FEET)}평C형`,
    subTitle: '48세대',
    subTitle02: '8',
    total: '9',
    detail: '부부공간과 자녀공간을 분리하여 공간별 프라이버시가 확보되고, \n2면 조망 거실공간을 갖춘 탑상형 구조'
  },
  {
    img: img4,
    title: '108㎡형',
    titleSwitchActive: `${Math.floor(138.4599 * CAL_FEET)}평형`,
    subTitle: '159세대',
    subTitle02: '8',
    total: '9',
    detail:
      '넉넉한 마스터룸 공간과 다양한 수납공간을 갖추어 보다 더 편리하며, \n맞통풍 평면설계를 통해 채광과 환기를 극대화한 판상형 구조'
  },
  {
    img: img5,
    title: '116㎡형',
    titleSwitchActive: `${Math.floor(147.8335 * CAL_FEET)}평형`,
    subTitle: '138세대',
    subTitle02: '8',
    total: '9',
    detail:
      '넉넉한 거실과 주방, 알파공간을 갖추어 공간은 보다 더 여유로우며, \n맞통풍 평면설계를 통해 채광과 환기를 극대화한 판상형 구조'
  }
];

/**
 * 개요의 세대정보 메뉴에서 계를 나타내는데 사용되는 데이터입니다.
 */
export const dataSlideResult = {
  title: '계',
  subTitle: '620세대',
  subTitle02: '169',
  total: '207'
};
